<template>
  <v-row>
    <!-- header -->
    <v-col class="col-12 pb-0 border-bottom border-top">
      <v-row class="justify-space-between align-center">
        <v-col class="col-8 font-weight-thin content-4 pt-0">
          <span v-if="range">
            {{ $t('shopBackendBookingComplete.dateRangeDescription') }}
          </span>
          <span v-else>
            {{ $t('booking.selectDate') }}
          </span>
        </v-col>
        <v-col class="col-4 text-end pt-0">
          <date-picker-today-button
            :date-picker-object="$refs.datePicker"
            @clicked="todayBtnCLicked"
          />
        </v-col>
      </v-row>
    </v-col>
    <!-- date picker -->
    <v-col class="col-12 py-0">
      <v-date-picker
        ref="datePicker"
        v-model="selectedDates"
        class="elevation-0"
        :range="range"
        :first-day-of-week="1"
        :locale="$store.getters.getLanguageLocale()"
        full-width
        event-color="green"
        no-title
        color="primary"
        cale
        @input="emitDateSelection"
      />
    </v-col>
  </v-row>
</template>

<script>
import moment from 'moment'
import DatePickerTodayButton from './DatePickerTodayButton'

export default {
  name: 'BookingDatePicker',
  components: { DatePickerTodayButton },
  props: {
    range: {
      type: Boolean,
      required: false,
      default: true,
    },
    initialDateRange: {
      type: Object,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      selectedDates: this.range ? [] : new Date().toISOString().substr(0, 10),
    }
  },
  async mounted() {
    if (this.initialDateRange !== null && this.range) {
      this.selectedDates = [
        this.$options.filters.formatDate(
          this.initialDateRange.from,
          'YYYY-MM-DD'
        ),
        this.$options.filters.formatDate(
          this.initialDateRange.to,
          'YYYY-MM-DD'
        ),
      ]
    }
    this.emitDateSelection()
  },
  methods: {
    emitDateSelection() {
      this.$emit('selected', this.getDateRange())
    },
    getDateRange() {
      let from = null
      let to = null
      if (this.range) {
        if (this.selectedDates.length === 1) {
          from = this.selectedDates[0]
          to = this.selectedDates[0]
        } else if (this.selectedDates.length > 1) {
          // get first date as to date
          if (
            moment(this.selectedDates[0]).valueOf() >
            moment(this.selectedDates[1]).valueOf()
          ) {
            from = this.selectedDates[1]
            to = this.selectedDates[0]
          } else {
            from = this.selectedDates[0]
            to = this.selectedDates[1]
          }
        } else {
          from = moment().hours(0).minutes(0).seconds(0).milliseconds(0)
          to = moment().hours(0).minutes(0).seconds(0).milliseconds(0)
        }
      } else {
        // in case its a single date select...
        from = this.selectedDates
        to = this.selectedDates
      }

      return { from: moment(from), to: moment(to) }
    },
    todayBtnCLicked() {
      if (this.range) {
        this.selectedDates = [new Date().toISOString().substr(0, 10)]
      } else {
        this.selectedDates = new Date().toISOString().substr(0, 10)
      }
      this.emitDateSelection()
    },
  },
}
</script>

<style scoped lang="scss"></style>
